export default __webpack_public_path__ + "static/media/Group_7_moderate.eeaf5e95.svg";